import { Injectable } from "@angular/core";

export interface IImportNotificationData{
    success: boolean;
    tableName: string;
    message: string;
}

export interface ImportNotificationListener {
    (event: IImportNotificationData): void
}

export interface ImportNotificationDisposable {
    dispose();
}



@Injectable({
    providedIn: 'root'
})
export class ImportNotificationService {

    private listeners: ImportNotificationListener[] = [];
    //_callbacks: Function[] = [];

    subscribe = (callback: ImportNotificationListener): ImportNotificationDisposable => {
        this.listeners.push(callback);

        return {
            dispose: () => {
                this.unSubscribe(callback);
            }
        }
    }

    unSubscribe = (callback: ImportNotificationListener): void => {
        var callbackIndex = this.listeners.indexOf(callback);
        if (callbackIndex > -1) this.listeners.splice(callbackIndex, 1);
    }

    trigger = (data: IImportNotificationData): void => {
        this.listeners.forEach((listener) => listener(data));
    }
}